// For google maps api
import { Controller } from "@hotwired/stimulus"
import * as myMap from "./maps";
import {defaultMapOptions, resolveMapTypeId, layerManager} from "./maps";
import { stopLinkBeingFollowed } from "./maps"
import { mapInfoPanel } from "./map_info_panel"

// the map is stored in a global (this.map)
export default class extends Controller {
  static targets = ['map', 'aaz', 'toggleRestrictedAirspace', 'toggleCraneZones', 'safeguardingVisible', 'infoPanel', 'infoPanelContent']

  // Use centralized toggle method
  async toggleLayer(event) {
    await layerManager.handleToggleLayer(event);
  }

  async resetMap(event) {
    stopLinkBeingFollowed(event)
    this.closeInfoPanel();
    let mapCentreLat = this.data.get("mapCentreLat");
    let mapCentreLon = this.data.get("mapCentreLon");
    const zoom = parseInt(this.data.get("defaultZoom")) || 12;
    const mapType = resolveMapTypeId(this.data.get("defaultMapType"));
    this.map.setOptions(defaultMapOptions(mapCentreLat, mapCentreLon, zoom, mapType));
    await layerManager.resetAllLayerDefaults(this.element, 'aaz-map');
  }

  async connect() {
    // console.log('aaz map controller');

    let mapCentreLat = this.data.get("mapCentreLat");
    let mapCentreLon = this.data.get("mapCentreLon");
    const zoom = parseInt(this.data.get("defaultZoom")) || 12;
    const mapType = resolveMapTypeId(this.data.get("defaultMapType"));

    let map = new google.maps.Map(this.mapTarget, myMap.defaultMapOptions(mapCentreLat, mapCentreLon, zoom, mapType));
    this.map = map
    await layerManager.initializeLayers(this.map, this);

    myMap.addGetBoundsFunction();

    // Setup info panel for layer feature information
    if (this.hasInfoPanelTarget && this.hasInfoPanelContentTarget) {
      mapInfoPanel.setup(this, this.infoPanelTarget, this.infoPanelContentTarget, this.map);
    }

    // Draw AAZ polygons (these are the actual auto-approval zones, not overlay layers)
    const aazType = this.data.get("type"); // "flight" for drone AAZ, "crane" for crane AAZ
    const aazTypeForInfo = aazType === "crane" ? "crane" : "drone";

    for (let aaz of this.aazTargets) {
      let polyPath = aaz.dataset.polygon; // can't use data.get because it is not unique to controller
      let name = aaz.dataset.name;
      let description = aaz.dataset.description;
      layerManager.drawAAZPolygonWithInfo(this.map, polyPath, name, aazTypeForInfo, description);
    }
  }

  // Info panel methods
  closeInfoPanel() {
    mapInfoPanel.close();
  }

}
